'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _difference2 = require('lodash/difference');

var _difference3 = _interopRequireDefault(_difference2);

var _result2 = require('lodash/result');

var _result3 = _interopRequireDefault(_result2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _urijs = require('urijs');

var _urijs2 = _interopRequireDefault(_urijs);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _DropdownButton = require('react-bootstrap/lib/DropdownButton');

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _mightyFields = require('../../lib/mighty-fields');

var _common = require('../common');

var _util = require('../../utils/util');

var _ConfigurableReportsSideModal = require('./ConfigurableReportsSideModal');

var _ConfigurableReportsSideModal2 = _interopRequireDefault(_ConfigurableReportsSideModal);

var _ReportSidebar = require('./ReportSidebar');

var _ReportSidebar2 = _interopRequireDefault(_ReportSidebar);

var _ReportTable = require('./ReportTable');

var _ReportTable2 = _interopRequireDefault(_ReportTable);

var _SavedReportDropdownItem = require('./SavedReportDropdownItem');

var _SavedReportDropdownItem2 = _interopRequireDefault(_SavedReportDropdownItem);

var _Columns = require('./Columns');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var TOOLTIP_CSV_EXPORT = 'toolip-csv-export';

var ReportPage = (_dec = (0, _mobxReact.inject)('FunderStore', 'ReportStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(ReportPage, _Component);

  function ReportPage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReportPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportPage.__proto__ || Object.getPrototypeOf(ReportPage)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'currentPageNumber', _descriptor, _this), _initDefineProp(_this, 'filters', _descriptor2, _this), _initDefineProp(_this, 'nextPageURL', _descriptor3, _this), _initDefineProp(_this, 'ordering', _descriptor4, _this), _initDefineProp(_this, 'previousPageURL', _descriptor5, _this), _initDefineProp(_this, 'sidebarCounts', _descriptor6, _this), _initDefineProp(_this, 'summary', _descriptor7, _this), _initDefineProp(_this, 'tableData', _descriptor8, _this), _initDefineProp(_this, 'tableType', _descriptor9, _this), _initDefineProp(_this, 'total', _descriptor10, _this), _initDefineProp(_this, 'accessibleFields', _descriptor11, _this), _initDefineProp(_this, 'configuredFields', _descriptor12, _this), _initDefineProp(_this, 'savedReports', _descriptor13, _this), _initDefineProp(_this, 'loading', _descriptor14, _this), _initDefineProp(_this, 'searchedResults', _descriptor15, _this), _initDefineProp(_this, 'searchTerm', _descriptor16, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReportPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          filters = _props.UiStore.reportPage.filters,
          ReportStore = _props.ReportStore;

      this.tableType = filters.table_type = ReportStore.tableType;
      if (!filters.status) {
        filters.status = 'open';
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var reportPage = this.props.UiStore.reportPage;


      this.handleFilterChange();
      this.preFetchSavedReports();
      this.ordering = (0, _result3.default)(reportPage, 'ordering', '');
      this.currentPageNumber = '1';
    }
  }, {
    key: 'getDefaultFields',
    value: function getDefaultFields(fields, tableType) {
      var fieldsToRemove = [].concat(_toConsumableArray(_Columns.REMOVED_DEFAULT_FIELDS[tableType]), _toConsumableArray(this.customFields));
      return (0, _difference3.default)(fields, fieldsToRemove);
    }
  }, {
    key: 'changeFilters',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isResettingAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                this.currentPageNumber = '1';
                _context.next = 4;
                return this.handleFilterChange(isResettingAll);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeFilters() {
        return _ref2.apply(this, arguments);
      }

      return changeFilters;
    }()
  }, {
    key: 'handleFilterChange',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var isResettingAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _props2, ReportStore, SessionStore, reportPage, filters, ordering, fields, params, reportsPromise, data, _data$headers, accessible_fields, configured_fields, defaultFields;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props2 = this.props, ReportStore = _props2.ReportStore, SessionStore = _props2.SessionStore, reportPage = _props2.UiStore.reportPage, filters = reportPage.filters, ordering = reportPage.ordering, fields = reportPage.fields, params = _extends({}, filters, { fields: fields, ordering: ordering, page: this.currentPageNumber }), reportsPromise = ReportStore.fetchReports(params);


                ReportStore.fetchSummary(params).then((0, _mobx.action)(function (summary) {
                  _this2.summary = summary;
                }));
                ReportStore.fetchCounts(params).then((0, _mobx.action)(function (counts) {
                  _this2.sidebarCounts = counts;
                }));

                _context2.next = 5;
                return reportsPromise;

              case 5:
                data = _context2.sent;
                _data$headers = data.headers;
                accessible_fields = _data$headers.accessible_fields;
                configured_fields = _data$headers.configured_fields;
                defaultFields = this.getDefaultFields(configured_fields, filters.table_type);


                !isResettingAll && SessionStore.trackEvent('REPORT_FILTER_CHANGE', reportPage.asJSON);

                this.tableType = filters.table_type;
                this.filters = filters;
                this.tableData = data.results;
                this.nextPageURL = data.next;
                this.accessibleFields = accessible_fields;
                this.configuredFields = !fields.length ? defaultFields : configured_fields;
                this.total = data.count;
                this.previousPageURL = data.previous;
                this.loading = false;

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleFilterChange() {
        return _ref3.apply(this, arguments);
      }

      return handleFilterChange;
    }()
  }, {
    key: 'preFetchSavedReports',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var savedReports;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.props.ReportStore.fetchSavedReports();

              case 2:
                savedReports = _context3.sent;


                this.savedReports = savedReports;
                this.searchedResults = savedReports;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function preFetchSavedReports() {
        return _ref4.apply(this, arguments);
      }

      return preFetchSavedReports;
    }()
  }, {
    key: 'saveReport',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref6) {
        var label = _ref6.label;

        var _props3, ReportStore, funderStaff, SaveReport, funder, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _props3 = this.props, ReportStore = _props3.ReportStore, funderStaff = _props3.FunderStore.funderStaff, SaveReport = _props3.UiStore.modals.SaveReport, funder = funderStaff.funder, data = {
                  configuration: {
                    fields: this.configuredFields,
                    filters: this.filters
                  },
                  created_by: funderStaff.id,
                  funder: funder,
                  label: label
                };
                _context4.next = 3;
                return ReportStore.saveReport(data, funder);

              case 3:
                _context4.next = 5;
                return ReportStore.fetchSavedReports();

              case 5:
                this.savedReports = _context4.sent;

                SaveReport.close();

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function saveReport(_x3) {
        return _ref5.apply(this, arguments);
      }

      return saveReport;
    }()
  }, {
    key: 'deleteReport',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        var ReportStore;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ReportStore = this.props.ReportStore;
                _context5.next = 3;
                return ReportStore.deleteReport(id);

              case 3:
                _context5.next = 5;
                return ReportStore.fetchSavedReports();

              case 5:
                this.savedReports = _context5.sent;

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deleteReport(_x4) {
        return _ref7.apply(this, arguments);
      }

      return deleteReport;
    }()
  }, {
    key: 'downloadCSV',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _props4, ReportStore, reportPage, filters;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _props4 = this.props, ReportStore = _props4.ReportStore, reportPage = _props4.UiStore.reportPage, filters = reportPage.asJSON;
                _context6.next = 3;
                return ReportStore.exportCSV(_extends({}, filters, { fields: [].concat(_toConsumableArray(this.configuredFields)) }));

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function downloadCSV() {
        return _ref8.apply(this, arguments);
      }

      return downloadCSV;
    }()
  }, {
    key: 'handleSort',
    value: function handleSort(sortString) {
      this.ordering = sortString;
      this.changeFilters();
    }
  }, {
    key: 'handlePagination',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(page) {
        var query;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                query = _urijs2.default.parse(page).query;

                this.loading = true;
                this.currentPageNumber = (0, _util.setPagination)(query);
                _context7.next = 5;
                return this.handleFilterChange();

              case 5:
                this.loading = false;

              case 6:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function handlePagination(_x5) {
        return _ref9.apply(this, arguments);
      }

      return handlePagination;
    }()
  }, {
    key: 'onSavedReportClick',
    value: function onSavedReportClick(report) {
      var _report$configuration = report.configuration,
          fields = _report$configuration.fields,
          filters = _report$configuration.filters,
          reportPage = this.props.UiStore.reportPage;

      reportPage.fields = fields;
      reportPage.filters = filters;
      this.changeFilters();
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader(summary) {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'col-values' },
        _Columns.HEADER_COLUMNS.map(function (col) {
          return col.accessor in summary && _react2.default.createElement(
            'div',
            { key: col.accessor },
            _react2.default.createElement(
              'h4',
              null,
              typeof col.renderLabel === 'function' && col.renderLabel(_this3.tableType) || col.renderLabel
            ),
            _react2.default.createElement(
              'div',
              { className: 'value' },
              col.formatValue(summary[col.accessor])
            )
          );
        })
      );
    }
  }, {
    key: 'onSearchChange',
    value: function onSearchChange(event) {
      var searchTerm = event.target.value,
          filteredReports = this.savedReports.filter(function (report) {
        return report.label.toLowerCase().includes(searchTerm.toLowerCase());
      });

      this.searchTerm = searchTerm;
      this.searchedResults = filteredReports;
    }
  }, {
    key: 'handleEventPropagation',
    value: function handleEventPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'renderSavedReportsDropdown',
    value: function renderSavedReportsDropdown() {
      var _this4 = this;

      return _react2.default.createElement(
        _DropdownButton2.default,
        {
          bsStyle: 'primary',
          bsSize: 'small',
          id: 'saved-reports-dropdown',
          title: 'Saved Reports',
          pullRight: true
        },
        _react2.default.createElement(
          _MenuItem2.default,
          {
            className: 'action',
            onClick: this.props.UiStore.modals.SaveReport.open
          },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
            ' Save New Report'
          )
        ),
        _react2.default.createElement(
          _MenuItem2.default,
          null,
          _react2.default.createElement('input', {
            type: 'text',
            placeholder: 'Search for a saved report...',
            id: 'saved-reports-search',
            value: this.searchTerm,
            onChange: this.onSearchChange,
            onClick: this.handleEventPropagation,
            onFocus: this.handleEventPropagation
          })
        ),
        !!this.savedReports.length && _react2.default.createElement(_MenuItem2.default, { divider: true }),
        !!this.searchedResults.length && this.searchedResults.map(function (report) {
          return _react2.default.createElement(_SavedReportDropdownItem2.default, {
            key: report.id,
            report: report,
            onSavedReportClick: _this4.onSavedReportClick,
            onDeleteReport: _this4.deleteReport
          });
        })
      );
    }
  }, {
    key: 'renderMoreDropdown',


    // This Dropdown is only visible when the screen is smaller than 1440px
    value: function renderMoreDropdown() {
      var _props5 = this.props,
          UiStore = _props5.UiStore,
          ReportStore = _props5.ReportStore;


      return _react2.default.createElement(
        _DropdownButton2.default,
        {
          bsStyle: 'primary',
          bsSize: 'small',
          className: 'dropdown-more dropdown-filter-multi',
          id: 'reports_more_dropdown',
          title: 'More',
          pullRight: true
        },
        _react2.default.createElement(
          _MenuItem2.default,
          { onClick: UiStore.modals.ConfigurableReports.open },
          'Configure'
        ),
        _react2.default.createElement(
          _MenuItem2.default,
          _extends({
            disabled: !ReportStore.canExportReports.isTrue,
            onClick: this.downloadCSV
          }, this.disabledExportTooltipProps),
          this.exportText
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          ReportStore = _props6.ReportStore,
          UiStore = _props6.UiStore;


      return _react2.default.createElement(
        _common.Page,
        { name: 'reports', type: 'list', hasSidebar: true },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Reports' }),
        _react2.default.createElement(
          _common.Page.Sidebar,
          null,
          _react2.default.createElement(_ReportSidebar2.default, {
            accessibleFields: (0, _mobx.toJS)(this.accessibleFields),
            changeFilters: this.changeFilters,
            filters: this.filters,
            handleSort: this.handleSort,
            loading: this.loading,
            ordering: this.ordering,
            sidebarCounts: this.sidebarCounts,
            tableType: this.tableType
          })
        ),
        _react2.default.createElement(
          _common.Page.Content,
          null,
          _react2.default.createElement(
            'div',
            { className: 'heading' },
            this.renderHeader((0, _mobx.toJS)(this.summary) || {}),
            _react2.default.createElement(
              'div',
              { className: 'col-buttons' },
              this.renderSavedReportsDropdown(),
              this.renderMoreDropdown(),
              _react2.default.createElement(
                _Button2.default,
                {
                  bsSize: 'small',
                  bsStyle: 'primary',
                  className: 'btn-configure',
                  onClick: UiStore.modals.ConfigurableReports.open
                },
                _react2.default.createElement(_common.Icon, { type: 'bars' }),
                ' Configure'
              ),
              _react2.default.createElement(
                _Button2.default,
                {
                  bsSize: 'small',
                  bsStyle: 'primary',
                  className: 'btn-export',
                  disabled: !ReportStore.canExportReports.isTrue,
                  onClick: this.downloadCSV
                },
                _react2.default.createElement(
                  'span',
                  this.disabledExportTooltipProps,
                  this.exportText
                )
              ),
              _react2.default.createElement(
                'small',
                null,
                'Reports are refreshed every 15 minutes'
              )
            )
          ),
          _react2.default.createElement(_ReportTable2.default, {
            configuredFields: this.configuredFields,
            currentPageNumber: this.currentPageNumber,
            customFields: (0, _mobx.toJS)(this.customFields),
            handlePagination: this.handlePagination,
            handleSort: this.handleSort,
            loading: this.loading,
            nextPageURL: this.nextPageURL,
            ordering: this.ordering,
            previousPageURL: this.previousPageURL,
            tableData: this.tableData,
            tableType: this.tableType,
            total: this.total
          })
        ),
        UiStore.modals.ConfigurableReports.showing() && _react2.default.createElement(_ConfigurableReportsSideModal2.default, {
          accessibleFields: (0, _mobx.toJS)(this.accessibleFields),
          changeFilters: this.changeFilters,
          tableType: this.tableType,
          customFields: (0, _mobx.toJS)(this.customFields),
          onClose: UiStore.modals.ConfigurableReports.close,
          configuredFields: (0, _mobx.toJS)(this.configuredFields)
        }),
        UiStore.modals.SaveReport.showing() && _react2.default.createElement(_mightyFields.FormModal, {
          className: 'modal-save-report',
          fieldSets: [[{ field: 'label' }]],
          onSave: this.saveReport,
          onClose: UiStore.modals.SaveReport.close,
          title: 'Name Current Report'
        }),
        _react2.default.createElement(_reactTooltip2.default, { effect: 'solid', html: true, id: TOOLTIP_CSV_EXPORT, place: 'bottom', type: 'info' })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'customFields',
    get: function get() {
      var _props$FunderStore$fu = this.props.FunderStore.funder,
          custom_case_fields = _props$FunderStore$fu.custom_case_fields,
          custom_lien_fields = _props$FunderStore$fu.custom_lien_fields,
          tableTypeFields = {
        'generic-lien': custom_lien_fields.concat(custom_case_fields),
        'lien': custom_lien_fields.concat(custom_case_fields),
        'medical-funding-case': custom_case_fields,
        'medical-lien': custom_lien_fields,
        'plaintiff-funding-case': custom_case_fields
      };


      return tableTypeFields[this.tableType] || [];
    }
  }, {
    key: 'exportText',
    get: function get() {
      return this.props.ReportStore.canExportReports.isTrue ? 'Export' : 'Exporting...';
    }
  }, {
    key: 'disabledExportTooltipProps',
    get: function get() {
      return {
        'data-for': TOOLTIP_CSV_EXPORT,
        'data-place': 'left',
        'data-tip': 'Only one report CSV can be exported at a time.',
        'data-tip-disable': this.props.ReportStore.canExportReports.isTrue
      };
    }
  }]);

  return ReportPage;
}(_react.Component), _class3.propTypes = {
  FunderStore: _propTypes2.default.object,
  ReportStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'currentPageNumber', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'filters', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'nextPageURL', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'ordering', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'previousPageURL', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'sidebarCounts', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'summary', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, 'tableData', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, 'tableType', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, 'total', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, 'accessibleFields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, 'configuredFields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, 'savedReports', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, 'searchedResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, 'searchTerm', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'customFields', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'customFields'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'exportText', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'exportText'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'changeFilters', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'changeFilters'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFilterChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handleFilterChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'preFetchSavedReports', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'preFetchSavedReports'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'saveReport', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'saveReport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'deleteReport', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'deleteReport'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'downloadCSV', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'downloadCSV'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePagination', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'handlePagination'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = ReportPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TOOLTIP_CSV_EXPORT, 'TOOLTIP_CSV_EXPORT', '/app/src/components/page-reports/ReportPage.js');
  reactHotLoader.register(ReportPage, 'ReportPage', '/app/src/components/page-reports/ReportPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-reports/ReportPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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